/**
  * Map Abstraction
  */
const L = require('leaflet');
//Constructor
export function AbstractMap(element, map) {
  this.element = element; // DOM node
  this.map = element;
}

AbstractMap.prototype.init = function () {
  this.finalize();
}

AbstractMap.prototype.finalize = function () {
  this.onReady();
}

// Should be called when
AbstractMap.prototype.onReady = function () {
  console.log("AbstractMap::onReady()");
}

AbstractMap.prototype.onZoom = function () { }
AbstractMap.prototype.onDragStart = function () { }
AbstractMap.prototype.onDrag = function () { }
AbstractMap.prototype.onDragEnd = function () { }
AbstractMap.prototype.onIdle = function () { }
AbstractMap.prototype.onTouchStart = function () { }
AbstractMap.prototype.onTouchMove = function () { }
AbstractMap.prototype.onTouchEnd = function () { }

AbstractMap.prototype.setZoom = function (zoom) { }
AbstractMap.prototype.setCenter = function (ll) { }
AbstractMap.prototype.pixToLL = function (point) { }
AbstractMap.prototype.llToPix = function (latLng) { }
AbstractMap.prototype.fromLatLngToDivPixel = function (latLng) { return null; }
AbstractMap.prototype.fromDivPixelToLatLng = function (xy) { return null; }
AbstractMap.prototype.useWheel = function () { }
AbstractMap.prototype.getZoom = function () { return 0; }
AbstractMap.prototype.setZoom = function (zoom) { }
AbstractMap.prototype.placeCustomMarker = function (lat, lon, url, w, h) { }
AbstractMap.prototype.placeCustomHtmlMarker = function (lat, lon, args) { }
AbstractMap.prototype.getCenterLat = function () { return 0; }
AbstractMap.prototype.getCenterLon = function () { return 0; }
AbstractMap.prototype.getBoundsN = function () { return 0; }
AbstractMap.prototype.getBoundsS = function () { return 0; }
AbstractMap.prototype.getBoundsW = function () { return 0; }
AbstractMap.prototype.getBoundsE = function () { return 0; }
AbstractMap.prototype.newLLPoint = function (lat, lng) { return null; }
AbstractMap.prototype.newXYPoint = function (x, y) { return null; }
AbstractMap.prototype.newGroundOverlay = function (url, sw, ne, opacity, clickable) { return null; }
AbstractMap.prototype.newPolygon = function (options) { return null; }
AbstractMap.prototype.newPolyline = function (options) { return null; }
AbstractMap.prototype.newMarker = function (options, clickCallback, mouseOverCallback, mouseOutCallback) { return null; }
AbstractMap.prototype.newSize = function (w, h) { return null; }
AbstractMap.prototype.newInfoWindow = function (options, reference) { return null; }
AbstractMap.prototype.getDiv = function () { return null; } //map's div

// Realization of map
export function LeafMap(element, options) {
  AbstractMap.call(this, element);
}

LeafMap.prototype = Object.create(AbstractMap.prototype);
LeafMap.prototype.constructor = LeafMap;

LeafMap.prototype.init = function () {
  var self = this;

  this.map.on('zoomend', function () { self.onZoom(); self.onIdle(); });
  this.map.on('movestart', function () {
    self.onDragStart();
  });
  this.map.on('moveend', function () {
    self.onDragEnd();
    self.onIdle();
  });

  setTimeout(this.finalize.bind(this), 50);
}

LeafMap.prototype.finalize = function () {
  this.onReady();
}

LeafMap.prototype.setZoom = function (zoom) {
  this.map.setZoom(parseInt(zoom));
}
LeafMap.prototype.getZoom = function () {
  return parseInt(this.map.getZoom());
}
LeafMap.prototype.setCenter = function (ll) {
  this.map.panTo(ll);
}
LeafMap.prototype.fromDivPixelToLatLng = function (xy) {
  var latlng = this.map.layerPointToLatLng(xy);

  return {
    lat: function () { return latlng.lat; },
    lng: function () { return latlng.lng; }
  };
}

LeafMap.prototype.useWheel = function () {
  this.map.scrollWheelZoom(true);
}

LeafMap.prototype.placeCustomMarker = function (lat, lon, url, w, h) {
  var centerPoint = L.latLng(lat, lon);

  var image = L.divIcon({
    iconSize: L.Point(40, 20),
    iconAnchor: L.Point(20, 20),
    html: '<img src="' + url + '" width="' + w + '" height="' + h + '" />',
    className: 'mapfit-div-icon-custom',
    icon: image
  });
  new L.Marker(centerPoint).addTo(this.map);
}

LeafMap.prototype.llToPix = function (latLng) {

  var topRight = this.map.latLngToLayerPoint(this.map.getBounds().getNorthEast());
  var bottomLeft = this.map.latLngToLayerPoint(this.map.getBounds().getSouthWest());
  var scale = parseInt(this.map.getZoom());
  var worldPoint = this.map.latLngToLayerPoint({
    lat: latLng.lat(),
    lng: latLng.lng()
  });

  return L.point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale);
}

LeafMap.prototype.pixToLL = function (point) {
  var topRight = this.map.latLngToLayerPoint(this.map.getBounds().getNorthEast());
  var bottomLeft = this.map.latLngToLayerPoint(this.map.getBounds().getSouthWest());
  var scale = parseInt(this.map.getZoom());
  // division by zero fix
  var scaleDivision = scale;
  if (scaleDivision == 0) {
  	scaleDivision = 1;
  }

  var newLatlng = this.map.layerPointToLatLng(
    L.point(point.x / scaleDivision + bottomLeft.x, point.y / scaleDivision + topRight.y)
  );

  return {
    lat: function () { return newLatlng.lat; },
    lng: function () { return newLatlng.lng; }
  };
}

LeafMap.prototype.newSize = function (w, h) {
  return { w: w, h: h };
}

LeafMap.prototype.getCenterLat = function () { return this.map.getCenter().lat; }
LeafMap.prototype.getCenterLon = function () { return this.map.getCenter().lng; }
LeafMap.prototype.getBoundsN = function () { return this.map.getBounds().getNorthEast().lat; }
LeafMap.prototype.getBoundsS = function () { return this.map.getBounds().getSouthWest().lat; }
LeafMap.prototype.getBoundsW = function () { return this.map.getBounds().getSouthWest().lng; }
LeafMap.prototype.getBoundsE = function () { return this.map.getBounds().getNorthEast().lng; }
LeafMap.prototype.newLLPoint = function (lat, lng) {
  var ltlg = L.latLng(lat, lng);
  return {
    lat: function () { return ltlg.lat; },
    lng: function () { return ltlg.lng; }
  };
}
LeafMap.prototype.newXYPoint = function (x, y) { return L.point(x, y); }

LeafMap.prototype.newGroundOverlay = function (url, sw, ne, opacity, clickable, loadFunction = null, hide=false, errorFunction=null, updateFromUrl=false) {
  var imageUrl = updateFromUrl ? "" : url;
   var imageBounds = [{
    lat: ne.lat(),
    lng: ne.lng()
  }, {
    lat: sw.lat(),
    lng: sw.lng()
  }];

  var overlay = L.imageOverlay(imageUrl, imageBounds, {
    opacity: opacity,
    zIndex: 2,
    alt: 'Weather pattern',
    interactive: true,
    crossOrigin: 'anonymous',
    errorOverlayUrl: './leaflet/error_image.png', // you would put an error url to an image here
    className: 'image-one ' + (hide ? 'hidden-layer' : ''),
  });
  if (!updateFromUrl) {
    if(loadFunction)
      overlay.on('load', loadFunction);
    if(errorFunction)
      overlay.on('error', errorFunction);
  }

  overlay.addTo(this.map);

  if(updateFromUrl && loadFunction)
    loadFunction(overlay, url);

  return overlay;
}
LeafMap.prototype.fromLatLngToDivPixel = function (latLng) {
  if (typeof latLng === 'undefined') {
    return { x: 0, y: 0 }
  }
  return this.map.latLngToLayerPoint({ lat: latLng.lat(), lng: latLng.lng() });
}
LeafMap.prototype.getDiv = function () {
  return this.map.getContainer();
}
